import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { FilterMenu } from '../FilterMenu.js';
import { noop } from '../../../utils/noop.js';
import { FilterButton } from '../FilterButton/component.js';

var BaseFilter = function BaseFilter(props) {
  var children = props.children,
      active = props.active,
      disabled = props.disabled,
      overrideIsOpen = props.isOpen,
      label = props.label,
      _props$onToggleOpen = props.onToggleOpen,
      onToggleOpen = _props$onToggleOpen === void 0 ? noop : _props$onToggleOpen,
      selected = props.selected,
      selectedIcon = props.selectedIcon,
      selectedIconFamily = props.selectedIconFamily,
      isWrapper = props.isWrapper,
      dataObjectType = props.dataObjectType,
      dataAction = props.dataAction,
      _props$hideFilterMenu = props.hideFilterMenu,
      hideFilterMenu = _props$hideFilterMenu === void 0 ? false : _props$hideFilterMenu;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  if (isWrapper) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  if (typeof overrideIsOpen !== 'undefined') {
    isOpen = overrideIsOpen;
  }

  var toggleOpen = function toggleOpen(isOpen) {
    setIsOpen(isOpen);
    onToggleOpen(isOpen);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "filter-pill",
    "data-object-type": dataObjectType,
    "data-action": dataAction
  }, /*#__PURE__*/React.createElement(FilterButton, {
    label: label,
    selected: selected // @ts-ignore Remove once FilterButton is converted to TypeScript
    ,
    icon: selectedIcon,
    iconFamily: selectedIconFamily,
    disabled: disabled,
    onClick: function onClick() {
      return toggleOpen(true);
    },
    highlighted: active
  }), isOpen && /*#__PURE__*/React.createElement(FilterMenu, {
    className: hideFilterMenu ? 'hide-filter-menu' : ''
  }, children), isOpen && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return toggleOpen(false);
    },
    className: "filter-blocker"
  }));
};

BaseFilter.displayName = "BaseFilter";
export { BaseFilter };